'use strict';

import './HomePage.less';
import React from 'react';
import _ from 'lodash';

import RoundButton from 'ck-core-client/source/ui/RoundButton';
import HowItWorks from '../../ui/system/HowItWorks';
import ProductOverview from '../../ui/carousel/ProductOverview';
import lang from './HomePageLang';
import MinecraftPaymentPlans from '../../ui/MinecraftPaymentPlans';
import { GenericLandingAboveFold } from './GenericLandingAboveFold';
import { LeadCaptureEmailBanner } from 'ck-core-client/source/components/LeadCaptureEmailBanner';
import WhatsIncludedCarousel from '../../ui/carousel/WhatsIncludedCarousel';
import { EmailCaptureModal } from 'ck-core-client/source/components/Modal/EmailCapture';
import VideoModal from 'ck-core-client/source/components/Modal/Video';
import shouldShowEmailCaptureModal from '../../ui/shouldShowEmailCaptureModal';
import hasSubmittedEmail from '../../ui/hasSubmittedEmail';
import { withAppContext } from 'ck-core-client/source/context';
import { UpgradePlanBanner } from 'ck-website/source/components/upgrades/UpgradePlanBanner';
import CloudImageFrame from '../../ui/system/CloudImageFrame';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';
import Animation from 'ck-core-client/source/ui/Animation';
import SocialCarousel from '../../ui/carousel/SocialCarousel';
import SocialReviews from '../../ui/system/SocialReviews';

export class HomePage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isVideoModalOpen: false,
			videoId: null,
			showModal: false
		};

		props.appContext.trackers.trackAdwordsRemarketing();

		if (CK.fn.inTest('LandingPageFlowProcess')) {
			this.testPage = 'LandingPageFlowProcess';
		} else if (CK.fn.inTest('LandingPageEducational')) {
			this.testPage = 'LandingPageEducational';
		}

		this.isInMobileTest =
			CK.fn.inTest('ParentsLandingPageMobile') && bowser.mobile && !hasSubmittedEmail();
	}

	// componentDidMount() {
	// 	this._showEmailModalTimeout = setTimeout(() => {
	// 		if (CK.checkoutStagesMounted) {
	// 			return;
	// 		}
	// 		// This is causing the inline home page checkout to be wiped out
	// 		// We also don't want to show this modal if the checkout is open anyway
	// 		// Use the CK global as a rubbish hack to avoid keeping state here
	// 		// about whether the checkout is open
	// 		this.setState({
	// 			showModal: shouldShowEmailCaptureModal() || this.state.showModal
	// 		});
	// 	}, _.get(CK, ['config', 'forceEmailCaptureModalTimeout'], 30000));
	// }

	// componentWillUnmount() {
	// 	clearTimeout(this._showEmailModalTimeout);
	// }

	componentDidMount() {
		this.ouibounce = window.ouibounce(undefined, {
			aggressive: true,
			timer: 0,
			callback: () => {
				if (!CK.user.$exists()) {
					this.setState({
						showModal: shouldShowEmailCaptureModal()
					});
				}
			}
		});
	}
	componentWillUnmount() {
		this.ouibounce.disable();
	}

	render() {
		const { appContext } = this.props;
		const { trackers } = appContext;

		return (
			<div className="HomePage">
				<EmailCaptureModal
					open={this.state.showModal}
					trackers={trackers}
					onClose={() =>
						this.setState({
							showModal: false
						})
					}
				/>
				{this.state.isVideoModalOpen ? (
					<VideoModal
						videoId={this.state.videoId}
						onClose={() => this.setState({ isVideoModalOpen: false })}
					/>
				) : null}

				<GenericLandingAboveFold
					title={`<span class="firstLine">Learn to code</span> <br />
					<span class="minecraft">Minecraft mods</span> &
					<span class="roblox">Roblox games</span>`}
					subtitle="Start your coding journey with interactive game creation courses. Use our beginner-friendly code editor and progress at your own pace to build your dream games. For ages 8-14."
					imageName="image-roblox-publish-games"
					videoFallbackName="image-roblox-publish-games"
					videoName="coolmath-landing"
					showArrow={true}
					button={
						<RoundButton
							handleClick={() =>
								document.getElementById('PlansIdWrapper').scrollIntoView({ behavior: 'smooth' })
							}
							buttonClass="watchVideoDesktop"
							text="View Plans"
							colour="yellow"
							size="medium"
							hoverAnimation="hvr-bounce-in"
						/>
					}
				/>

				<div className="belowFold">
					<HowItWorks langKey="GENERIC" />

					{/* <div className="importanceOfCode">
						<div className="maxWidthContentWrapper">
							<div className="title">{lang.IMPORTANCE_OF_CODE.TITLE}</div>
							<div className="subtitle">{lang.IMPORTANCE_OF_CODE.SUBTITLE}</div>
							<div className="buttons">
								<RoundButton
									buttonClass="watchVideo"
									handleClick={() =>
										this.setState({
											isVideoModalOpen: true,
											videoId: '60767036'
										})
									}
									text={lang.IMPORTANCE_OF_CODE.BUTTON}
									colour="red"
									icon="button-play-icon"
									size="medium"
									hoverAnimation="hvr-bounce-in"
								/>
							</div>
						</div>
					</div> */}

					<ProductOverview />

					<WhatsIncludedCarousel langKey="GENERIC" />

					<SocialReviews langKey="PARENTS">
						<div className="carouselFrame">
							<SocialCarousel />
						</div>
					</SocialReviews>
				</div>

				{this.isInMobileTest ? null : CK.user.getLatestActiveProduct() ? (
					<UpgradePlanBanner />
				) : (
					<MinecraftPaymentPlans />
				)}

				{<LeadCaptureEmailBanner trackers={trackers} />}
			</div>
		);
	}
}

export const title = require('ck-core-client/source/functions/generatePageTitle')(lang.SEO_TITLE);
export const fullWidth = true;
export const ConnectedHomePage = withAppContext(HomePage);

// TODO RROC: For legacy routing system
export default ConnectedHomePage;
